class Controller {
  constructor($scope) {
    "ngInject";

    this.$scope = $scope;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/loadingSpinner/loadingSpinner.controller.js